import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import callBackDesktopImg from "../../../assets/images/main-home/get_a_call_back_desktop.png";
import callBackDesktopImgHindi from "../../../assets/images/main-home/hindi/get_a_call_back_desktop.png";
import styles from "./GetInTouchWithUs.module.css";
import callBackSuccessImg from "../../../assets/images/main-home/get_a_call_back_success.png";
import callBackMobileImg from "../../../assets/images/main-home/get_a_call_back_mobile.png";
import { Validation } from "../../../_helpers/validation/Validation";
import {
  ContactUsService,
  callbackRequest,
} from "../../../_services/CommnService/ContactUs/ContactUsService";
import toastr from "toastr";
import MultiLanguageTranslation from "../../../_components/Translate/MultiLangTranslate";
import ReCAPTCHA from "react-google-recaptcha";
import ValidationError from "../arya2.0/CommonComponents/ValidationError/ValidationError";
import { captchaKey } from "../../../_constants/Config/AryaConstants";
import GetInTouch from "../arya2.0/GetInTouch/GetInTouch";
import "../../_webapp/arya2.0/commonStyle.css";
import useIsUserLoggedIn from "../arya2.0/CustomHooks/useIsUserLoggedIn";
import { useTranslation } from "react-i18next";
export default function MandiPriceWidget(props) {
  const { t: translation } = useTranslation();
  const [callBackSuccess, setcallBackSuccess] = useState();
  const [error, setError] = useState({});
  const [first_name, setName] = useState("");
  const [phone_number, setPhoneNumber] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaKeyRest, setCaptchaKeyRest] = useState(0);
  const history = useHistory();
  const [lang, setLang] = useState("en");
  const [isUserLoggedIn] = useIsUserLoggedIn();
  useEffect(() => {
    let lang = localStorage.getItem("lang");
    setLang(lang);
  });
  const isMobile = window.matchMedia(
    "only screen and (max-width: 991px)"
  ).matches;

  const FormCustomField = [
    {
      field_name: "first_name",
      label: "Name",
      type: "string",
      isRequired: true,
    },
    {
      field_name: "phone_number",
      label: "Phone number",
      type: "phone",
      // min: 10,
      // max: 13,
      isRequired: true,
    },
  ];
  const onChange = (e) => {
    if (e.target.name === "first_name") {
      setName(e.target.value);
    } else {
      setPhoneNumber(e.target.value);
    }
  };
  let createFormData = () => {
    var objdata = {
      first_name: first_name,
      phone_number: phone_number,
      captcha_token: captchaToken,
    };
    return objdata;
  };
  const handleRefresh = () => {
    setCaptchaKeyRest((prevKey) => prevKey + 1);
  };
  const captchChange = (value) => {
    // setError({ ...error, ["captchaToken"]: "" });
    setCaptchaToken(value);
    setError((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };

  const onExpired = (value) => {
    setCaptchaToken("");
    // setData((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };
  let unsetFormData = () => {
    setName("");
    setPhoneNumber("");
    setError({});
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    var errobj = {};
    var re = new RegExp("^([a-zA-Z',.-]+( [a-zA-Z',.-]+)*)$");
    /**call validation file for validation */
    errobj = Validation({ first_name, phone_number }, FormCustomField);
    if (first_name !== "" && !re.test(first_name)) {
      errobj.first_name = "Enter Valid Name";
    }
    if (!isUserLoggedIn && !captchaToken) {
      errobj.captchaToken = translation(
        "Please check the box indicating 'I am not a robot' to submit your application"
      );
    }
    setError(errobj);
    /**
     * final checking for any error exists or not
     */
    var flag = 0;
    console.log(errobj);
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      setcallBackSuccess(true);
      var registerdata = createFormData();
      const result = await ContactUsService.callbackRequest(registerdata);
      if (result && result.data && result.data.status_code === 200) {
        toastr.info("Thank You");
        handleRefresh();
      } else {
        setcallBackSuccess(false);
      }
    }
  };
  return callBackSuccess === true ? (
    <div
      className={`mt-4 ${styles["get-in-touch-body"]} ${
        styles["get-in-touch-success"]
      } ${
        isMobile ? styles["m-get-in-touch-success"] : ""
      } section1 pt10 mlrauto w80 col-12 d-flex flex-column justify-content-between`}
    >
      <div>
        {/* <h5>
          <MultiLanguageTranslation title="Get in touch with aryaag" />
        </h5> */}
        <p style={{ marginBottom: "0px" }}>
          <MultiLanguageTranslation title="Your request for call back has been registered" />
          .
        </p>
        <p>
          <MultiLanguageTranslation title="Our customer care representative will reach out to you soon" />
        </p>
      </div>
      <img src={callBackSuccessImg} alt="" />
    </div>
  ) : isMobile ? (
    // <form
    //   onSubmit={onSubmit.bind(this)}
    //   className={`mt-4 ${styles["get-in-touch-body-form"]}`}
    // >
    //   <div
    //     className={`${styles["get-in-touch-body"]} ${styles["m-get-in-touch-body"]} section1 pt10 mlrauto d-flex col-12 p-0`}
    //   >
    //     <div className="col-5 p-0" style={{ overflow: "hidden" }}>
    //       <h5>
    //         <MultiLanguageTranslation title="Get in touch with us" />
    //       </h5>
    //       <img
    //         src={
    //           lang === "hindi" ? callBackDesktopImgHindi : callBackDesktopImg
    //         }
    //         alt=""
    //         className=""
    //       />
    //     </div>
    //     <div
    //       className={`col-7 p-0 d-flex flex-column justify-content-end align-items-center ${styles["flex-basis-0"]}`}
    //     >
    //       <div
    //         className={`d-flex flex-column col-12 p-1 ${styles["flex-basis-0"]}`}
    //       >
    //         <label htmlFor="">
    //           <MultiLanguageTranslation title="Your Name" />{" "}
    //           <span className="red">*</span>
    //         </label>
    //         <input
    //           type="text"
    //           placeholder="eg. Deepak Saxena"
    //           name="first_name"
    //           onChange={onChange.bind(this)}
    //           value={first_name}
    //         />
    //         {console.log(error)}
    //         {error.first_name && error.first_name !== "" && (
    //           <div className={`fromerror ${styles["error"]}`}>
    //             {error.first_name}
    //           </div>
    //         )}
    //       </div>
    //       <div
    //         className={`col-12 d-flex flex-column p-1 ${styles["flex-basis-0"]}`}
    //       >
    //         <label htmlFor="">
    //           <MultiLanguageTranslation title="Your Contact Number" />{" "}
    //           <span className="red">*</span>
    //         </label>
    //         <div className={`col-12 ${styles["flex-basis-0"]} pl-0 d-flex`}>
    //           <div
    //             className={`col-3 ${styles["contact-code"]} ${styles["m-contact-code"]} p-0`}
    //           >
    //             +91
    //           </div>
    //           <input
    //             type="text"
    //             className={`col-10 ${styles["contact-number"]} ${
    //               error.phone_number && error.phone_number !== "" && "mb-1"
    //             }`}
    //             onChange={onChange.bind(this)}
    //             name="phone_number"
    //             value={phone_number}
    //           />
    //           {error.phone_number && error.phone_number !== "" ? (
    //             <div className={`fromerror ${styles["error"]}`}>
    //               {error.phone_number}
    //             </div>
    //           ) : (
    //             ""
    //           )}
    //         </div>
    //       </div>
    //       <div className="mb-4 mt-4">
    //         <div className="w-100">
    //           <ReCAPTCHA
    //             sitekey={captchaKey}
    //             onChange={captchChange}
    //             onExpired={onExpired}
    //           />
    //           {error.captchaToken && (
    //             <ValidationError
    //               text={error.captchaToken}
    //               // imageClassName={"mb-auto"}
    //               // textClassName={style["input-error-style-radio"]}
    //             />
    //           )}
    //         </div>
    //       </div>
    //       <div
    //         className={`col-12 p-1 ${
    //           error.phone_number && error.phone_number !== "" ? "mt-2" : "mt-0"
    //         } ${styles["flex-basis-0"]}`}
    //       >
    //         <button type="submit" className="col-12 btn submitbtn">
    //           <MultiLanguageTranslation title="Request a Callback" />
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </form>
    <GetInTouch />
  ) : (
    <form onSubmit={onSubmit.bind(this)} className="mt-4">
      <div
        className={`${styles["get-in-touch-body"]} section1 pt10  mlrauto col-12 p-4 d-flex`}
      >
        <div className="col-4 p-0">
          <h5>
            <MultiLanguageTranslation title="Get in touch with us" />
          </h5>
          <img
            src={lang == "hindi" ? callBackDesktopImgHindi : callBackDesktopImg}
            alt=""
            className=""
          />
        </div>
        <div className="col-8 p-0 d-flex flex-wrap justify-content-center align-items-center">
          <div className="d-flex flex-column col-6">
            <label htmlFor="">
              <MultiLanguageTranslation title="Your Name" />{" "}
              <span className="red">*</span>
            </label>
            <input
              type="text"
              placeholder="eg. Deepak Saxena"
              name="first_name"
              onChange={onChange.bind(this)}
              value={first_name.first_name}
            />
            {error.first_name && error.first_name !== "" && (
              <div className={`fromerror ${styles["error"]}`}>
                {error.first_name}
              </div>
            )}
          </div>
          <div className="d-flex flex-column col-6">
            <label htmlFor="">
              <MultiLanguageTranslation title="Your Contact Number" />
              <span className="red">*</span>
            </label>
            <div className="col-12 p-0 d-flex">
              {" "}
              <div className={`${styles["contact-code"]} col-3`}>+91</div>
              <input
                type="text"
                className={` ${styles["contact-number"]} col-9`}
                onChange={onChange.bind(this)}
                name="phone_number"
                value={phone_number.phone_number}
              />
            </div>
            {error.phone_number && error.phone_number !== "" && (
              <div className={`fromerror ${styles["error"]}`}>
                {error.phone_number}
              </div>
            )}
          </div>
          {!isUserLoggedIn && (
            <div className="mb-4 mt-4">
              <div className="w-100">
                <ReCAPTCHA
                  key={captchaKeyRest}
                  sitekey={captchaKey}
                  onChange={captchChange}
                  onExpired={onExpired}
                />
                {error.captchaToken && (
                  <ValidationError
                    text={error.captchaToken}
                    showIcon={false}
                    textClassName={"fromerror mt-2"}
                    // imageClassName={"mb-auto"}
                    // textClassName={style["input-error-style-radio"]}
                  />
                )}
              </div>
            </div>
          )}
          <div className="col-9 p-0">
            <button type="submit" className="btn submitbtn col-12">
              <MultiLanguageTranslation title="Request a Callback" />
            </button>
            {/* <input type="submit" value="Request a Callback" className="col-12" /> */}
          </div>
        </div>
      </div>
    </form>
  );
}
